module.exports = __webpack_public_path__ + "static/media/nossa-estrutura.322c50c6.webp";